<template>
  <div class="pv">
    <div class="pv__before">
      <div class="pv__label">优化前</div>
      <div class="pv__before-text">夏季新款女装连衣裙宽松版</div>
    </div>
    <div v-if="phase >= 1" class="pv__optimizing">AI优化中 ✦</div>
    <div v-if="phase >= 2" class="pv__after">
      <div class="pv__label pv__label--gold">优化后 ↑ AI推荐</div>
      <div class="pv__after-text">2025夏季新款法式连衣裙 宽松显瘦 气质仙女裙 大码女装</div>
    </div>
    <div class="pv__score">
      <span class="pv__score-label">质量分</span>
      <div class="pv__bar">
        <div
          class="pv__bar-fill"
          :style="{ width: score + '%', background: phase < 2 ? 'linear-gradient(90deg,#E85D5D,#F0C44A)' : 'linear-gradient(90deg,#D4A946,#F0C44A)' }"
        ></div>
      </div>
      <span class="pv__score-val" :style="{ color: score > 80 ? '#D4A946' : '#E85D5D' }">{{ score }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrevOptimize',
  props: { run: { type: Boolean, default: false } },
  data() {
    return { phase: 0, score: 52, timers: [], timer: null }
  },
  watch: {
    run(v) {
      this.timers.forEach(t => clearTimeout(t))
      if (this.timer) clearInterval(this.timer)
      if (!v) { this.phase = 0; this.score = 52; return }
      this.timers.push(setTimeout(() => { this.phase = 1 }, 600))
      this.timers.push(setTimeout(() => { this.phase = 2 }, 1800))
      this.timer = setInterval(() => {
        if (this.score >= 94) { clearInterval(this.timer); return }
        this.score += 2
      }, 80)
    }
  },
  beforeDestroy() {
    this.timers.forEach(t => clearTimeout(t))
    if (this.timer) clearInterval(this.timer)
  }
}
</script>

<style scoped>
.pv { width: 100%; }
.pv__before {
  margin-bottom: 8px;
  padding: 8px 10px;
  border-radius: 8px;
  background: rgba(255, 255, 255, .04);
  border: 1px solid rgba(255, 255, 255, .08);
}
.pv__label { font-size: 9px; color: #8A95B0; margin-bottom: 3px; }
.pv__label--gold { color: #D4A946; }
.pv__before-text { font-size: 11px; color: rgba(220, 215, 240, .45); line-height: 1.5; }
.pv__optimizing { text-align: center; color: #D4A946; font-size: 12px; margin-bottom: 6px; animation: gx-revealUp .3s both; }
.pv__after {
  margin-bottom: 8px;
  padding: 8px 10px;
  border-radius: 8px;
  background: rgba(212, 169, 70, .08);
  border: 1px solid rgba(212, 169, 70, .35);
  animation: gx-revealUp .4s both;
}
.pv__after-text { font-size: 11px; color: #F0EBE0; line-height: 1.5; }
.pv__score { display: flex; align-items: center; gap: 8px; }
.pv__score-label { font-size: 10px; color: #8A95B0; flex-shrink: 0; }
.pv__bar { flex: 1; height: 5px; border-radius: 3px; background: rgba(255, 255, 255, .08); overflow: hidden; }
.pv__bar-fill { height: 100%; border-radius: 3px; transition: width .08s; }
.pv__score-val { font-family: Inter; font-size: 11px; font-weight: 700; width: 24px; }
</style>
